import script from "./DashBoard.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashBoard.vue?vue&type=script&lang=ts&setup=true"

import "./DashBoard.vue?vue&type=style&index=0&id=98c18e2a&lang=scss&scoped=true"

import exportComponent from "D:\\肖虹\\软件工程与UML\\《软件工程》\\UML面向对象分析，建模和设计\\项目案例\\机票预订系统的文档与代码（前后端分离）\\源代码\\前端代码\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98c18e2a"]])

export default __exports__